import CryptoJS from 'crypto-js'; // ES6 标准引入
/**
 * 防抖函数
 *
 * @param {*} fn 回调方法
 * @param {*} delay 延迟时间
 * @returns
 */
export function debounce(fn, delay, ...extraArgs) {
  let timer = null;

  return function () {
    timer && clearTimeout(timer);

    let content = this;
    let args = [...arguments, ...extraArgs];
    timer = setTimeout(() => {
      fn.apply(content, args);
    }, delay);
  };
}

/**
 * 节流函数
 *
 * @param {*} fn 回调方法
 * @param {*} delay 延迟时间
 * @returns
 */
export function throttle(fn, delay, call = function () {}) {
  let lastTime = 0;

  return function () {
    // 获取当前时间戳
    let now = new Date().getTime();

    // 如果当前时间减去上次时间大于限制时间时才执行
    if (now - lastTime > delay) {
      lastTime = now;
      fn.apply(this, arguments);
    } else {
      call();
    }
  };
}

/**
 * 剪贴板复制功能
 *
 * @param {String} text 复制内容
 * @param {Function} callback 复制成功回调方法
 */
export function clipboard(text, callback) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      callback && callback();
    })
    .catch(() => {
      alert('Oops, unable to copy');
    });
}

export async function clipboardImage(src, callback) {
  const { state } = await navigator.permissions.query({
    name: 'clipboard-write' // 不能将类型""clipboard-write""分配给类型PermissionName。
  });

  if (state != 'granted') return;

  try {
    const data = await fetch(src);
    const blob = await data.blob();

    // navigator.clipboard.write 仅支持 png 图片
    if (blob.type == 'image/png') {
      await navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]);

      return callback();
    }

    const objectURL = URL.createObjectURL(blob);

    const img = new Image();
    img.src = URL.createObjectURL(blob);
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        blob => {
          const data = [new ClipboardItem({ [blob.type]: blob })];

          navigator.clipboard
            .write(data)
            .then(() => {
              callback();
            })
            .catch(err => {
              console.error(err);
            });

          URL.revokeObjectURL(objectURL);
        },
        'image/png',
        1
      );
    };
  } catch (err) {
    console.error(err.name, err.message);
  }
}

export function hashStrToHexColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += value.toString(16).padStart(2, '0');
  }
  return color;
}

export function emitCall(event, data, fn) {
  return { event: event, data: data, callBack: fn || function () {} };
}

// 判断是否是客户端模式
export function isElectronMode() {
  return electron() != undefined;
}

export function electron() {
  return window.electron;
}

export function htmlDecode(input) {
  return input
    .replace(/&amp;/g, '&')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#34;/g, '"');
}

// 文件转 图片 关键函数  异步
export function getVideoImage(file, time = 1) {
  return new Promise(resolve => {
    let video = document.createElement('video');

    const objectURL = URL.createObjectURL(file);

    video.src = objectURL;
    video.currentTime = time;
    video.autoplay = true;
    video.muted = true;

    video.oncanplay = () => {
      let canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      let ctx = canvas.getContext('2d');
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

      let data = {
        url: canvas.toDataURL('image/jpeg', 1),
        width: video.videoWidth,
        height: video.videoHeight,
        duration: video.duration,
        file: null
      };

      canvas.toBlob(blob => {
        data.file = new File([blob], 'image.jpeg', {
          type: blob.type,
          lastModified: Date.now()
        });

        URL.revokeObjectURL(objectURL);

        resolve(data);
      }, 'image/jpeg');
    };
  });
}
// 工具函数：将 DataURL（Base64 编码）转换为 Blob 对象
export function dataURLtoBlob(dataURL) {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export function getFileExtension(file) {
  const filename = file.name;
  const dotIndex = filename.lastIndexOf('.');
  return dotIndex > 0 ? filename.substring(dotIndex + 1) : '';
}

// wav转mp3
export function convertToMp3(wavDataView, recorder) {
  // const wav = lamejs.WavHeader.readHeader(wavDataView);
  // const { channels, sampleRate } = wav;
  // const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
  // const result = recorder.getChannelData()
  // const buffer = [];
  // const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
  // const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
  // const remaining = leftData.length + (rightData ? rightData.length : 0);
  // const maxSamples = 1152;
  // for (let i = 0; i < remaining; i += maxSamples) {
  //     const left = leftData.subarray(i, i + maxSamples);
  //     let right = null;
  //     let mp3buf = null;
  //     if (channels === 2) {
  //         right = rightData.subarray(i, i + maxSamples);
  //         mp3buf = mp3enc.encodeBuffer(left, right);
  //     } else {
  //         mp3buf = mp3enc.encodeBuffer(left);
  //     }
  //     if (mp3buf.length > 0) {
  //         buffer.push(mp3buf);
  //     }
  // }
  // const enc = mp3enc.flush();
  // if (enc.length > 0) {
  //     buffer.push(enc);
  // }
  // return new Blob(buffer, { type: 'audio/mp3' });
}

export function isBase64(dataUrl) {
  // 仅检查是否有 'base64,' 前缀，不严格验证 Base64 格式
  const regex = /^data:image\/[a-zA-Z0-9]+;base64,/;

  return regex.test(dataUrl);
}

export function parseBase64Image(dataUrl) {
  // 正则表达式匹配图片数据的格式
  const regex = /^data:(image\/\w+);base64,(.+)$/;
  const matches = dataUrl.match(regex);

  if (!matches) {
    throw new Error('Invalid Base64 image data');
  }

  // 提取图片格式和Base64数据
  const mimeType = matches[1]; // 比如 "image/png" 或 "image/jpg"
  const base64Data = matches[2]; // 纯Base64数据

  return {
    mimeType,
    base64Data
  };
}

export function splitArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

//给当前路由添加额外参数 要考虑当前有没有参数
export function addExtraParams(params) {
  const currentPath = window.location.pathname;
  const currentParams = new URLSearchParams(window.location.search);

  // 遍历要添加的参数 如果当前有参数 则添加到当前参数后面 如果没有参数 则添加到当前路径后面
  for (const key in params) {
    if (currentParams.has(key)) {
      currentParams.set(key, params[key]);
    } else {
      currentParams.append(key, params[key]);
    }
  }

  return `${currentPath}?${currentParams.toString()}`;
}

//取字符串的最后一位如果没有就给-
export function getLastChar(str) {
  str = (str || '-').toString();
  return str.charAt(str.length - 1);
}
//取字符串的第一位如果没有就给-
export function getFirstChar(str) {
  str = (str || '-').toString();
  return str.charAt(0) || '-';
}

// 移除对象中的空值
export function removeEmptyKeys(obj: any): any {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) {
    return obj.map(removeEmptyKeys).filter(item => item !== null && item !== undefined);
  }

  return Object.entries(obj).reduce((acc: any, [key, value]) => {
    if (value === null || value === undefined || value === '') {
      return acc;
    }
    if (typeof value === 'object') {
      const cleaned = removeEmptyKeys(value);
      if (Object.keys(cleaned).length > 0) {
        acc[key] = cleaned;
      }
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}
//判断新对象和老对象相同属性是否相同 加个参数 哪些属性不用
export function isObjectEqual(newObj, oldObj, excludeParams = []) {
  if (
    typeof newObj !== 'object' ||
    typeof oldObj !== 'object' ||
    newObj === null ||
    oldObj === null
  )
    return false;

  const keysToCompare = new Set(
    Object.keys(newObj).length < Object.keys(oldObj).length
      ? Object.keys(newObj)
      : Object.keys(oldObj)
  );

  for (const key of keysToCompare) {
    if (excludeParams.includes(key)) continue;
    if (newObj.hasOwnProperty(key) && oldObj.hasOwnProperty(key)) {
      if (newObj[key] !== oldObj[key]) return false;
    } else {
      return false;
    }
  }
  return true;
}

// 加密函数
export const encryptAES = (password: string, secretKey: string) => {
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(password),
    CryptoJS.enc.Utf8.parse(secretKey),
    {
      mode: CryptoJS.mode.ECB, // ECB 模式（需与后端协商）
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return encrypted.toString();
};

/**
 * 判断两个对象是否相等
 */
function isObjectEquals(obj1: Record<string, any>, obj2: Record<string, any>): boolean {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // 如果属性数量不同，对象一定不相等
  if (keys1.length !== keys2.length) return false;

  // 检查所有属性值是否相等
  return keys1.every(key => obj1[key] === obj2[key]);
}

/**
 * 判断两个对象数组是否存在包含关系
 * @param arr1 第一个对象数组
 * @param arr2 第二个对象数组
 * @returns 如果较小的数组中的所有对象都能在较大的数组中找到匹配，返回true
 */
export function isArrayContained(
  arr1: Record<string, any>[],
  arr2: Record<string, any>[]
): boolean {
  // 确定哪个是较短的数组
  const [shorterArr, longerArr] = arr1.length <= arr2.length ? [arr1, arr2] : [arr2, arr1];

  // 检查较短数组中的每个对象是否都能在较长数组中找到匹配
  return shorterArr.every(shortObj => longerArr.some(longObj => isObjectEquals(shortObj, longObj)));
}

// 生成随机订单ID
export const generateOrderId = () => {
  const timestamp = Date.now().toString();
  const random = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0');
  return `RECH${timestamp}${random}`;
};

//写一个区块链trc20 随机交易hash
export const generateTrc20TransactionHash = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

//将数字保留两位小数
export const formatNumber = (num: string | number) => {
  return Number(num).toFixed(2);
};

/**
 * 生成带国家区号的随机手机号
 * @returns {{ phone: string, countryCode: string, fullNumber: string }} 返回手机号信息
 */
export const generateRandomPhoneNumber = () => {
  // 常用国家区号列表
  const countryCodes = [
    { code: '1', country: 'US' }, // 美国/加拿大
    { code: '44', country: 'GB' }, // 英国
    { code: '61', country: 'AU' }, // 澳大利亚
    { code: '64', country: 'NZ' }, // 新西兰
    { code: '65', country: 'SG' }, // 新加坡
    { code: '81', country: 'JP' }, // 日本
    { code: '82', country: 'KR' }, // 韩国
    { code: '852', country: 'HK' }, // 香港
    { code: '886', country: 'TW' } // 台湾
  ];
  // 随机选择一个国家区号
  const countryCode = countryCodes[Math.floor(Math.random() * countryCodes.length)];

  // 生成随机手机号 (8-10位数字)
  const length = Math.floor(Math.random() * 3) + 8; // 8-10位
  let phoneNumber = '';
  for (let i = 0; i < length; i++) {
    phoneNumber += Math.floor(Math.random() * 10);
  }

  return {
    phone: phoneNumber,
    countryCode: countryCode.code,
    country: countryCode.country,
    fullNumber: `+${countryCode.code}${phoneNumber}`
  };
};

/**
 * 生成随机账号加密码（带国家区号的手机号）
 * @param num 生成几个
 * @returns {{ account: string, pwd: string }[]} 返回账号密码信息
 */
export const generateRandomAccount = (num: number) => {
  const phoneInfo = generateRandomPhoneNumber();
  let account = phoneInfo.fullNumber;
  //账号要加随机的国家区号
  let pwd = Math.random().toString(36).substring(2, 15);
  let result = [];
  for (let i = 0; i < num; i++) {
    result.push({ account, pwd });
  }
  return result;
};

// 生成随机代理码
export const generateAgentCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * 复制文本到剪贴板
 * @param text 要复制的文本
 * @returns Promise<boolean> 是否复制成功
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // 方法1: 使用 clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // 方法2: 使用传统方法
    return fallbackCopy(text);
  } catch (error) {
    console.error('复制失败:', error);
    return false;
  }
};

/**
 * 传统复制方法
 * @param text 要复制的文本
 * @returns boolean 是否复制成功
 */
const fallbackCopy = (text: string): boolean => {
  try {
    // 创建临时输入框
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // 设置样式使其不可见
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);

    // 选择并复制文本
    textArea.focus();
    textArea.select();
    const successful = document.execCommand('copy');

    // 清理临时元素
    document.body.removeChild(textArea);

    return successful;
  } catch (error) {
    console.error('复制失败:', error);
    return false;
  }
};
